import { render, staticRenderFns } from "./SelectIrrelevant.vue?vue&type=template&id=78d791d6"
import script from "./SelectIrrelevant.vue?vue&type=script&lang=js"
export * from "./SelectIrrelevant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports